import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.scss'],
})
export class ModalAlertComponent {
  @Input() icono!:string;
  @Input() mensaje!:string;
  @Output() closeModalPlan = new EventEmitter();
  @Output() enviarSolicitud = new EventEmitter();
  @Input() cambioAplanDuo!: boolean;
 

  iconoAlerta = "/assets/icono-plans/alertamin.svg"
  mensajeAlerta6meses = "Para cambiarte de plan debes tener una permanencia de al menos <strong>6 meses</strong>  en tu plan actual."
  mensajeAlertaPlanDuo = "¿Estas seguro que no seleccionarás ningún beneficiario?. Si no deseas agregar cargas y pertenecer a este Plan, dale al botón Aceptar."
  mensajeAlertaCambioSinSAP = "No se encuentra el correo del colaborador en SAP"
  mensajeAlertaCambioContratoFijo = "No se puede cambiar el plan debido a su tipo de contrato <strong>Plazo Fijo</strong>."
  


  mensajeOption(){
    switch(this.mensaje){
      case 'alerta6Meses': //informativo
        return this.mensajeAlerta6meses
      case 'alertaPlanDuo': //solicita plan sin beneficio
        return this.mensajeAlertaPlanDuo
      case 'alertaCambioSinSap': //informativo
        return this.mensajeAlertaCambioSinSAP
      case 'alertaContratoFijo': //informativo
        return this.mensajeAlertaCambioContratoFijo
      default:
        return ''
    }
  }

  closeModal() {
    this.closeModalPlan.emit(false);
  }

  enviarSolicitudDowngrade(){
    if(this.cambioAplanDuo && this.mensaje === 'alertaPlanDuo'){
       this.enviarSolicitud.emit(true)
    }else{
      this.closeModal()
    }
   
  }



}
